<template>
  <div class="form-group">
    <file-upload
      :ref="`${id}-upload`"
      :value="value"
      :input-id="`${id}-files`"
      :multiple="true"
      @input="$emit('input', $event)"
    >
      <button class="btn btn-default upload-btn">
        Выбрать файл
      </button>
      <span class="text-muted text-uppercase">Приложите изображение (скриншот)</span>
    </file-upload>
    <ul>
      <li
        v-for="(file, index) in value"
        :key="file.id"
        :size="maxFilesSize"
      >
        {{ file.name }} <span class="text-muted">({{ file.size | formatSize }})</span> <i
          class="fa fa-fw fa-remove"
          @click="remove(index)"
        />
      </li>
    </ul>
    <c-alert
      v-if="!isFilesSizeCorrect(value, maxFilesSize)"
      type="warning"
    >
      Суммарный размер файлов не должен быть больше {{ maxFilesSize | formatSize }}
    </c-alert>
  </div>
</template>

<script>
import CAlert from './ui/CAlert'
import files from '../mixins/files'
import FileUpload from 'vue-upload-component'

/**
 * Загрузка файлов для модального окна.
 */
export default {
  name: 'ModalFilesUpload',
  components: {
    CAlert,
    FileUpload
  },
  mixins: [files],
  props: {
    /**
     * Файлы.
     *
     * @model
     */
    value: {
      type: Array,
      required: true
    },
    /**
     * Уникальный id. Необходим для корректной работы нескольких компонентов загрузки файлов одновременно.
     */
    id: {
      type: String,
      required: true
    },
    /**
     * Максимальный суммарный размер (в байтах) загружаемых файлов.
     */
    maxFilesSize: {
      type: Number,
      required: true
    }
  },
  methods: {
    /**
     * Удаляет файл из списка файлов к загрузке на сервер.
     *
     * @param {Number} index
     */
    remove (index) {
      const newFiles = [...this.value]
      newFiles.splice(index, 1)

      /**
       * Вызывается при изменении набора файлов.
       *
       * @property {Array} value Файлы.
       */
      this.$emit('input', newFiles)
    }
  }
}
</script>

<style scoped>
.fa-remove {
  cursor: pointer;
}

.upload-btn {
  margin-right: 15px;
}

</style>
